import supportModule from '../supportModule';

const resources = {
  templateUrls: {
    support: 'support',
    supportForm: 'support-form',
    ageGate: 'age-gate',
    chatLaunch: 'chat-launch'
  },
  apiSets: {
    getMetadataUrl: {
      url: '/support/metadata',
      retryable: true,
      withCredentials: true
    },
    getLoginUrl: {
      url: '/login',
      retryable: true,
      withCredentials: true
    },
    getAccountInfoUrl: {
      url: '/my/settings/json',
      retryable: true,
      withCredentials: true
    }
  },
  urls: {
    checkUsername: '/v1/usernames'
  }
};

supportModule.constant('resources', resources);

export default resources;
